export default function AuthHeader(session) {
    var jwtToken = session.accessToken.jwtToken
    return "Bearer "+jwtToken;
}